import React from 'react';
import styles from './Footer.module.css';

const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className={styles.footer}>
            <div className={styles.container}>
                {/* Main Content */}
                <div className={styles.content}>
                    {/* About Section */}
                    <div className={styles.section}>
                        <h3 className={styles.sectionTitle}>
                            <span className={styles.icon}>🏏</span>
                            BD Live Cric
                        </h3>
                        <p className={styles.sectionText}>
                            Stream live cricket, football, and more sports for free. Experience the best live sports streaming platform.
                        </p>
                        <div className={styles.socialLinks}>
                            <a href="#twitter" title="Twitter" className={styles.socialLink}>𝕏</a>
                            <a href="#facebook" title="Facebook" className={styles.socialLink}>f</a>
                            <a href="#instagram" title="Instagram" className={styles.socialLink}>📷</a>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className={styles.section}>
                        <h4 className={styles.subTitle}>Navigation</h4>
                        <ul className={styles.linkList}>
                            <li><a href="/">🏠 Home</a></li>
                            <li><a href="/events">📅 Events</a></li>
                            <li><a href="#live">🔴 Live Now</a></li>
                            <li><a href="#trending">🔥 Trending</a></li>
                        </ul>
                    </div>

                    {/* Legal */}
                    <div className={styles.section}>
                        <h4 className={styles.subTitle}>Legal</h4>
                        <ul className={styles.linkList}>
                            <li><a href="#privacy">Privacy Policy</a></li>
                            <li><a href="#terms">Terms of Service</a></li>
                            <li><a href="#dmca">DMCA</a></li>
                            <li><a href="#contact">Contact Us</a></li>
                        </ul>
                    </div>

                    {/* Support */}
                    <div className={styles.section}>
                        <h4 className={styles.subTitle}>Support</h4>
                        <p className={styles.contactText}>
                            Email: <a href="mailto:support@bdlivecric.com">support@bdlivecric.com</a>
                        </p>
                        <p className={styles.contactText}>
                            Available 24/7 for your support
                        </p>
                    </div>
                </div>

                {/* Divider */}
                <div className={styles.divider}></div>

                {/* Bottom */}
                <div className={styles.bottom}>
                    <p className={styles.copyright}>
                        © {currentYear} <strong>BD Live Cric</strong>. All rights reserved.
                    </p>
                    <p className={styles.disclaimer}>
                        We are not affiliated with any sports organizations or broadcasters.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;